import React, { forwardRef } from 'react'

import classNames from 'classnames'
import styled from 'styled-components'
import { AppstoreOutlined, PictureOutlined } from '@ant-design/icons'

interface DragPreviewProps {
  style?: React.CSSProperties
  hidden?: boolean
}

export const DragPreview = forwardRef<HTMLDivElement, DragPreviewProps>(
  ({ style, hidden }, ref) => {
    return (
      <SDragPreviewContainer
        ref={ref}
        style={style}
        className={classNames({
          hidden,
        })}
      >
        {<SDragPreviewLayout className='js-drag-preview-layout' />}

        <SDragPreview>
          <SGridIcon className='js-drag-preview-grid-icon' />
          <SPictureIcon className='js-drag-preview-picture-icon' />

          <SText className='js-drag-preview-text' />
        </SDragPreview>

        <SCount className='js-drag-preview-count' />
      </SDragPreviewContainer>
    )
  }
)

const SDragPreviewContainer = styled.div`
  width: 248px;
  height: 60px;
  position: relative;
  padding-top: 20px;
  background: transparent;
  overflow: hidden;

  &.hidden {
    display: none;
  }
`

const SDragPreviewLayout = styled.div`
  background: white;
  min-width: 240px;
  height: 48px;
  position: absolute;
  top: 24px;
  left: 4px;
  border-radius: 8px;
  opacity: 0.6;
`

const SDragPreview = styled.div`
  background: white;
  max-width: 240px;
  height: 48px;
  pointer-events: none;
  user-select: none;
  position: relative;
  border: 1px solid #0000000D;
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
`

const SCount = styled.span`
  position: absolute;
  top: 10px;
  right: 0px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #8747DF;
  border-radius: 50%;
  color: white;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid white;
`

const SGridIcon = styled(AppstoreOutlined)`
  margin-right: 8px;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.45);
`

const SPictureIcon = styled(PictureOutlined)`
  margin-right: 8px;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.45);
`

const SText = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #000000E0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`